module.exports = __webpack_public_path__ + "img/roll-1227.1fc46ca4.png";